import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

export interface QueryObject {
    [key: string]: any;
}

@Injectable({
    providedIn: 'root'
})
export class RequestsService {

    public static getQueryParams(obj: QueryObject, encoded = true): string {
        let str = '';
        if (obj) {
            for (const key in obj) {
                if (key in obj) {
                    if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
                        continue;
                    }
                    if (str !== '') {
                        str += '&';
                    }
                    if (Array.isArray(obj[key])) {
                        for (let i = 0; i < obj[key].length; i++) {
                            if (encoded) {
                                str += key + '=' + encodeURIComponent(obj[key][i]);
                            } else {
                                str += key + '=' + obj[key][i];
                            }
                            if (i !== obj[key].length - 1) {
                                str += '&';
                            }
                        }
                    } else {
                        if (encoded) {
                            str += key + '=' + encodeURIComponent(obj[key]);
                        } else {
                            str += key + '=' + obj[key];
                        }
                    }
                }
            }
        }
        return str ? `?${str}` : '';
    }

    constructor(
        private http: HttpClient
    ) {}

    public request(method: 'PUT' | 'POST' | 'DELETE' | 'GET' | 'PATCH', url: string, data?: any, options?: any, fullUrl?: boolean): Observable<any> {
        const apiLink = fullUrl ? url : `${environment.apiUrl}${url}`;
        if (method === 'POST') {
            return this.http.post(apiLink, data, options);
        } else if (method === 'PUT') {
            return this.http.put(apiLink, data, options);
        } else if (method === 'PATCH') {
            return this.http.patch(apiLink, data, options);
        } else if (method === 'DELETE') {
            return this.http.delete(`${apiLink}${RequestsService.getQueryParams(data)}`, options);
        } else {
            return this.http.get(`${apiLink}${RequestsService.getQueryParams(data)}`, options);
        }
    }

}
